<template>
<div class="card col p-0 shadow-" >
  <div class="card-body  " >
         <h2 class="card-title  align-self-center" > {{ servizio.nome }} </h2>
 <p class="card-text  align-self-center"> {{ servizio.descrizione }} </p>
</div>
 </div>
</template>

<script>

export default {
  name: 'card-servizio',
  props: {
    servizio: Object
  },
  data () {
    return {
      servizi: []
    }
  }
}
</script>
